// forms: [1 день, 2 дня, 5 дней]
export function pluralRu (count, forms) {
  const abs = Math.abs(count) % 100
  const tail = abs % 10

  if (abs > 10 && abs < 20) return forms[2]
  if (tail > 1 && tail < 5) return forms[1]
  if (tail === 1) return forms[0]

  return forms[2]
}

export function daysLabel (count) {
  return `${count} ${pluralRu(count, ['день', 'дня', 'дней'])}`
}

export function filialsLabel (count) {
  return `${count} ${pluralRu(count, ['филиал', 'филиала', 'филиалов'])}`
}
